export const leadsUserOverview = [
    {
        id: 1,
        title: "New",
        number: "20"
    },
    {
        id: 2,
        title: "Contacted",
        number: "15"
    },
    {
        id: 3,
        title: "Qualified",
        number: "10"
    },
    {
        id: 4,
        title: "Working",
        number: "18"
    },
    {
        id: 5,
        title: "Customer",
        number: "10"
    },
    {
        id: 6,
        title: "Proposal",
        number: "15"
    },
    {
        id: 7,
        title: "Leads",
        number: "16"
    },
    {
        id: 8,
        title: "Progress",
        number: "14"
    },
    {
        id: 9,
        title: "Others",
        number: "10"
    },

]